(function() {
  var root = document.getElementById('tg-receipt-root');
  if (!root) return;

  var apiUrl = root.dataset.api;

  function esc(s) {
    if (!s) return '';
    var el = document.createElement('span');
    el.textContent = s;
    return el.innerHTML;
  }

  function formatPrice(n) {
    var v = Math.round(parseFloat(n) || 0);
    return '&yen;' + v.toLocaleString('ja-JP');
  }

  var params = new URLSearchParams(window.location.search);
  var prefilledOrder = params.get('order') || '';

  root.innerHTML =
    '<div class="tg-rcpt-form-wrap">' +
      '<div class="tg-rcpt-form-header">' +
        '<h1 class="tg-rcpt-form-title">領収証発行</h1>' +
        '<p class="tg-rcpt-form-desc">ご注文番号とメールアドレスを入力してください。</p>' +
        '<p class="tg-rcpt-form-notice">※ 当社は適格請求書発行事業者ではないため、適格請求書（インボイス）の発行はできません。</p>' +
      '</div>' +
      '<form id="tgReceiptForm" class="tg-rcpt-form">' +
        '<div class="tg-rcpt-field">' +
          '<label for="tgOrderNum">注文番号</label>' +
          '<input type="text" id="tgOrderNum" placeholder="#1051" value="' + esc(prefilledOrder) + '" required autocomplete="off">' +
        '</div>' +
        '<div class="tg-rcpt-field">' +
          '<label for="tgEmail">メールアドレス</label>' +
          '<input type="email" id="tgEmail" placeholder="example@email.com" required autocomplete="email">' +
        '</div>' +
        '<div class="tg-rcpt-field">' +
          '<label for="tgAtena">宛名（任意）</label>' +
          '<input type="text" id="tgAtena" placeholder="空欄の場合はご注文者名が入ります" autocomplete="organization">' +
        '</div>' +
        '<div id="tgReceiptError" class="tg-rcpt-form-error" style="display:none"></div>' +
        '<button type="submit" id="tgReceiptSubmit" class="tg-rcpt-submit-btn">領収証を表示</button>' +
      '</form>' +
    '</div>';

  var form = document.getElementById('tgReceiptForm');
  var errorEl = document.getElementById('tgReceiptError');
  var submitBtn = document.getElementById('tgReceiptSubmit');

  form.addEventListener('submit', function(e) {
    e.preventDefault();
    errorEl.style.display = 'none';
    submitBtn.disabled = true;
    submitBtn.textContent = '読み込み中...';

    var orderNum = document.getElementById('tgOrderNum').value.trim();
    var email = document.getElementById('tgEmail').value.trim();

    var cbName = '_tgReceipt' + Date.now();
    var fetchUrl = apiUrl + '?order=' + encodeURIComponent(orderNum) +
      '&email=' + encodeURIComponent(email) +
      '&callback=' + cbName;

    var timeout = setTimeout(function() {
      delete window[cbName];
      errorEl.textContent = 'サーバーとの通信がタイムアウトしました。しばらく経ってから再度お試しください。';
      errorEl.style.display = 'block';
      submitBtn.disabled = false;
      submitBtn.textContent = '領収証を表示';
    }, 15000);

    window[cbName] = function(data) {
      clearTimeout(timeout);
      delete window[cbName];
      if (!data.ok) {
        errorEl.textContent = data.error || 'エラーが発生しました。';
        errorEl.style.display = 'block';
        submitBtn.disabled = false;
        submitBtn.textContent = '領収証を表示';
        return;
      }
      var customName = document.getElementById('tgAtena').value.trim();
      if (customName) {
        data.receipt.name = customName;
      }
      renderReceipt(data.receipt);
    };

    var script = document.createElement('script');
    script.src = fetchUrl;
    script.onerror = function() {
      clearTimeout(timeout);
      delete window[cbName];
      errorEl.textContent = 'サーバーとの通信に失敗しました。';
      errorEl.style.display = 'block';
      submitBtn.disabled = false;
      submitBtn.textContent = '領収証を表示';
    };
    document.body.appendChild(script);
  });

  function renderReceipt(r) {
    var itemsHtml = '';
    for (var i = 0; i < r.items.length; i++) {
      var it = r.items[i];
      var titleHtml = esc(it.title);
      if (it.variant) titleHtml += '<span class="tg-rcpt-variant"> / ' + esc(it.variant) + '</span>';

      var optHtml = '';
      if (it.options && it.options.length) {
        optHtml = '<div class="tg-rcpt-options">';
        for (var j = 0; j < it.options.length; j++) {
          optHtml += '<span class="tg-rcpt-opt">' + esc(it.options[j].name) + ': ' + esc(it.options[j].value) + '</span>';
        }
        optHtml += '</div>';
      }

      itemsHtml += '<tr><td>' + titleHtml + optHtml + '</td><td>' + it.quantity + '</td><td>' + formatPrice(it.price) + '</td></tr>';
    }

    var discountHtml = '';
    if (r.discount && r.discount > 0) {
      discountHtml = '<tr><td>割引</td><td>-' + formatPrice(r.discount) + '</td></tr>';
    }

    var receiptInner =
      '<div class="tg-rcpt-header"><h1 class="tg-rcpt-title">領 収 証</h1><p class="tg-rcpt-subtitle">RECEIPT</p></div>' +
      '<div class="tg-rcpt-to"><span class="tg-rcpt-to-name">' + esc(r.name) + '</span><span class="tg-rcpt-to-sama">様</span></div>' +
      '<div class="tg-rcpt-amount"><p class="tg-rcpt-amount-label">合計金額（税込）</p><p class="tg-rcpt-amount-value">' + formatPrice(r.total) + '</p></div>' +
      '<div class="tg-rcpt-meta"><span>注文番号: ' + esc(r.order) + '</span><span>取引日: ' + esc(r.date) + '</span></div>' +
      '<table class="tg-rcpt-table"><thead><tr><th>商品名</th><th>数量</th><th>金額</th></tr></thead><tbody>' + itemsHtml + '</tbody></table>' +
      '<table class="tg-rcpt-table tg-rcpt-summary">' +
      '<tr><td>小計</td><td>' + formatPrice(r.subtotal) + '</td></tr>' +
      discountHtml +
      '<tr><td>送料</td><td>' + formatPrice(r.shipping) + '</td></tr>' +
      '<tr class="total-row"><td>合計</td><td>' + formatPrice(r.total) + '</td></tr>' +
      // 当店は税込価格。消費税は内数なので、加算項目と同じ列に並べない。
      // 並べると 小計-割引+送料+消費税 が合計と一致せず、計算違いに見える。
      '<tr class="tax-row"><td>（内 消費税）</td><td>' + formatPrice(r.tax) + '</td></tr>' +
      '</table>' +
      '<div class="tg-rcpt-issuer"><div class="tg-rcpt-issuer-name">合同会社TITAN</div>' +
      '〒252-0336 神奈川県相模原市南区当麻1323番地1 当麻倉庫付事務所3-102<br>TEL: 042-711-8368<br>titan-pc.net</div>' +
      '<div class="tg-rcpt-note">但し　商品代として　上記正に領収いたしました。</div>' +
      // 印刷して客先の経理に渡ることがあるため、書面そのものにも断りを入れる
      '<div class="tg-rcpt-invoice-note">※ 当社は適格請求書発行事業者ではないため、'  +
      '本書は適格請求書（インボイス）ではありません。</div>';

    root.innerHTML =
      '<div class="tg-rcpt-actions">' +
        '<button id="tgReceiptPrint" class="tg-rcpt-print-btn">' +
        '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 6 2 18 2 18 9"/><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/><rect x="6" y="14" width="12" height="8"/></svg>' +
        '印刷する</button>' +
        '<button id="tgReceiptBack" class="tg-rcpt-back-btn">別の注文を検索</button>' +
      '</div>' +
      '<div class="tg-rcpt">' + receiptInner + '</div>';

    document.getElementById('tgReceiptPrint').addEventListener('click', function() {
      var w = window.open('', '_blank');
      if (!w) return;
      var doc = w.document;
      doc.open();
      doc.write('<!DOCTYPE html>');
      doc.write('<html lang="ja"><head><meta charset="utf-8">');
      doc.write('<title>領収証 ' + esc(r.order) + '</title>');
      doc.write('<style>');
      doc.write('*,*::before,*::after{box-sizing:border-box;margin:0;padding:0}');
      // 第1候補をVF(可変フォント)にすると、PDF保存時にChromiumが文字を画像(Type3)で
      // 埋め込み、文字が選択もコピーもできない粗いPDFになる。
      // 実体のあるフォント(Windows: Yu Gothic / Mac: Hiragino)を先に置いて回避する。
      doc.write('body{font-family:"Yu Gothic","Hiragino Kaku Gothic ProN","Zen Kaku Gothic New","Noto Sans JP",sans-serif;color:#1a1a1a;background:#fff;padding:40px;-webkit-print-color-adjust:exact;print-color-adjust:exact}');
      doc.write('.wrap{max-width:680px;margin:0 auto}');
      doc.write('.tg-rcpt-header{text-align:center;margin-bottom:36px}');
      doc.write('.tg-rcpt-title{font-size:28px;font-weight:700;letter-spacing:.3em;margin:0 0 4px}');
      doc.write('.tg-rcpt-subtitle{font-size:13px;color:#888;margin:0}');
      doc.write('.tg-rcpt-to{margin-bottom:32px;padding-bottom:16px;border-bottom:2px solid #1a1a1a}');
      doc.write('.tg-rcpt-to-name{font-size:20px;font-weight:600}');
      doc.write('.tg-rcpt-to-sama{font-size:14px;margin-left:8px}');
      doc.write('.tg-rcpt-amount{text-align:center;margin:28px 0;padding:20px;background:#f9f9f9;border:1px solid #eee;border-radius:8px}');
      doc.write('.tg-rcpt-amount-label{font-size:13px;color:#888;margin:0 0 4px}');
      doc.write('.tg-rcpt-amount-value{font-size:32px;font-weight:700;margin:0}');
      doc.write('.tg-rcpt-meta{display:flex;justify-content:space-between;margin-bottom:24px;font-size:14px;color:#555}');
      doc.write('.tg-rcpt-table{width:100%;border-collapse:collapse;margin-bottom:20px;font-size:14px}');
      doc.write('.tg-rcpt-table th{padding:8px 12px;text-align:left;border-bottom:2px solid #1a1a1a;font-weight:600;font-size:13px;color:#555}');
      doc.write('.tg-rcpt-table th:nth-child(2){text-align:center}');
      doc.write('.tg-rcpt-table th:nth-child(3){text-align:right}');
      doc.write('.tg-rcpt-table td{padding:6px 12px;border-bottom:1px solid #eee}');
      doc.write('.tg-rcpt-table td:nth-child(2){text-align:center}');
      doc.write('.tg-rcpt-table td:nth-child(3){text-align:right}');
      doc.write('.tg-rcpt-summary td{padding:4px 12px;font-size:14px;border:none}');
      doc.write('.tg-rcpt-summary td:first-child{text-align:right}');
      doc.write('.tg-rcpt-summary td:last-child{text-align:right;width:120px}');
      doc.write('.tg-rcpt-summary .total-row td{padding-top:8px;font-size:18px;font-weight:700;border-top:2px solid #1a1a1a}');
      doc.write('.tg-rcpt-issuer{margin-top:40px;padding-top:24px;border-top:1px solid #eee;font-size:13px;color:#555;line-height:1.8}');
      doc.write('.tg-rcpt-issuer-name{font-size:15px;font-weight:600;color:#1a1a1a;margin-bottom:4px}');
      doc.write('.tg-rcpt-summary .tax-row td{padding-top:2px;font-size:12px;color:#777}');
      doc.write('.tg-rcpt-note{margin-top:24px;font-size:12px;color:#999;text-align:center}');
      doc.write('.tg-rcpt-invoice-note{margin-top:8px;font-size:11px;color:#777;text-align:center}');
      doc.write('.tg-rcpt-variant{font-size:12px;color:#888}');
      doc.write('.tg-rcpt-options{margin-top:4px}');
      doc.write('.tg-rcpt-opt{display:inline-block;font-size:11px;color:#666;background:#f5f5f5;padding:2px 8px;border-radius:4px;margin:2px 4px 2px 0}');
      doc.write('.no-print{text-align:center;margin-bottom:24px}');
      doc.write('.no-print button{padding:10px 32px;font-size:15px;font-weight:600;background:#1a1a1a;color:#fff;border:none;border-radius:8px;cursor:pointer}');
      doc.write('@media print{.no-print{display:none!important}body{padding:20px}}');
      doc.write('</style>');
      doc.write('</head><body>');
      doc.write('<div class="no-print"><button onclick="window.print()">印刷する</button></div>');
      doc.write('<div class="wrap">' + receiptInner + '</div>');
      doc.write('</body></html>');
      doc.close();
    });

    document.getElementById('tgReceiptBack').addEventListener('click', function() {
      window.location.reload();
    });
  }
})();
